export const earningsReportData = [
  {
    key: "1",
    INVOICENO: "#INV12345",
    IMAGE: "avatar-20.jpg",
    NAME: "Andrew Simons",
    AMOUNT: "$120.00",
    PAYMENTMETHOD: "Credit Card",
    DATE: "24 Jan 2025",
    STATUS: "Completed",
  },
  {
    key: "2",
    INVOICENO: "#INV12346",
    IMAGE: "avatar-21.jpg",
    NAME: "David Steiger",
    AMOUNT: "$85.00",
    PAYMENTMETHOD: "Debit Card",
    DATE: "19 Dec 2024",
    STATUS: "Pending",
  },
  {
    key: "3",
    INVOICENO: "#INV12347",
    IMAGE: "avatar-12.jpg",
    NAME: "Virginia Phu",
    AMOUNT: "$250.00",
    PAYMENTMETHOD: "PayPal",
    DATE: "11 Dec 2024",
    STATUS: "Completed",
  },
  {
    key: "4",
    INVOICENO: "#INV12348",
    IMAGE: "avatar-22.jpg",
    NAME: "Walter Hartmann",
    AMOUNT: "$175.00",
    PAYMENTMETHOD: "Bank Transfer",
    DATE: "29 Nov 2024",
    STATUS: "Refunded",
  },
  {
    key: "5",
    INVOICENO: "#INV12349",
    IMAGE: "avatar-07.jpg",
    NAME: "Andrea Jermaine",
    AMOUNT: "$200.00",
    PAYMENTMETHOD: "Digital Payment",
    DATE: "03 Nov 2024",
    STATUS: "Completed",
  },
  {
    key: "6",
    INVOICENO: "#INV12350",
    IMAGE: "avatar-05.jpg",
    NAME: "Dennis Eckhardt",
    AMOUNT: "$90.00",
    PAYMENTMETHOD: "Credit Card",
    DATE: "31 Oct 2024",
    STATUS: "Pending",
  },
  {
    key: "7",
    INVOICENO: "#INV12351",
    IMAGE: "avatar-25.jpg",
    NAME: "Lan Adams",
    AMOUNT: "$160.00",
    PAYMENTMETHOD: "Debit Card",
    DATE: "15 Oct 2024",
    STATUS: "Completed",
  },
  {
    key: "8",
    INVOICENO: "#INV12352",
    IMAGE: "avatar-08.jpg",
    NAME: "Ann Crump",
    AMOUNT: "$180.00",
    PAYMENTMETHOD: "PayPal",
    DATE: "26 Sep 2024",
    STATUS: "Failed",
  },
  {
    key: "9",
    INVOICENO: "#INV12353",
    IMAGE: "avatar-07.jpg",
    NAME: "Julie Black",
    AMOUNT: "$230.00",
    PAYMENTMETHOD: "Bank Transfer",
    DATE: "01 Sep 2024",
    STATUS: "Completed",
  },
  {
    key: "10",
    INVOICENO: "#INV12354",
    IMAGE: "avatar-16.jpg",
    NAME: "Jean Walker",
    AMOUNT: "$300.00",
    PAYMENTMETHOD: "Digital Payment",
    DATE: "15 Aug 2024",
    STATUS: "Completed",
  },
];
